// LoginPage.jsx (harmonisé avec RegisterPage : carte glass, inputs avec icônes, même bouton, dark ok)

import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import backgroundImage from "./HeaderSlider_02.jpg";
import { useUser } from "./../../contexts/UserContext";
import { loginUser } from "./../../services/userServices";
import useScrollToTop from "./../../hooks/useScrollToTop";
import { FaEnvelope, FaLock } from "react-icons/fa";

function LoginPage() {
  useScrollToTop();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const { updateUser } = useUser();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setLoading(true);

    try {
      const data = await loginUser(email, password);

      if (!data?.userInfo || !data?.token) {
        setErrorMessage("Email ou mot de passe incorrect. Veuillez réessayer.");
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("userInfo", JSON.stringify(data.userInfo));
      updateUser(data.userInfo);

      navigate("/");
    } catch (error) {
      setErrorMessage(
        "Impossible de se connecter pour le moment. Veuillez réessayer plus tard."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-10"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="w-full max-w-md">
        <div className="rounded-3xl bg-white/90 backdrop-blur-sm shadow-2xl ring-1 ring-black/5 p-6 sm:p-8 dark:bg-slate-900/85 dark:ring-white/10">
          <h1 className="text-center text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white">
            Connexion
          </h1>
          <p className="text-center text-sm text-slate-600 mt-2 dark:text-slate-300">
            Connectez-vous pour accéder à votre espace.
          </p>

          {errorMessage && (
            <div className="mt-5 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-rose-800 text-sm dark:bg-rose-900/25 dark:border-rose-800/40 dark:text-rose-200">
              {errorMessage}
            </div>
          )}

          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            {/* Email */}
            <div>
              <label className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-300">
                Email
              </label>
              <div className="mt-1 flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 focus-within:ring-2 focus-within:ring-sky-400 dark:bg-slate-900 dark:border-slate-700">
                <FaEnvelope className="text-slate-400" />
                <input
                  type="email"
                  placeholder="Votre email"
                  className="w-full bg-transparent outline-none text-slate-900 placeholder:text-slate-400 dark:text-white"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-autofocus
                />
              </div>
            </div>

            {/* Mot de passe */}
            <div>
              <label className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-300">
                Mot de passe
              </label>
              <div className="mt-1 flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 focus-within:ring-2 focus-within:ring-sky-400 dark:bg-slate-900 dark:border-slate-700">
                <FaLock className="text-slate-400" />
                <input
                  type="password"
                  placeholder="Votre mot de passe"
                  className="w-full bg-transparent outline-none text-slate-900 placeholder:text-slate-400 dark:text-white"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full h-11 rounded-2xl bg-primary text-white font-semibold shadow-sm transition active:scale-[0.99] hover:opacity-95 disabled:opacity-60"
            >
              {loading ? "Connexion…" : "Se connecter"}
            </button>

            <div className="flex items-center justify-between pt-1 text-sm">
              <Link
                to="/forgot-password"
                className="font-semibold text-sky-700 hover:underline dark:text-sky-300"
              >
                Mot de passe oublié ?
              </Link>

              <button
                type="button"
                onClick={() => navigate("/register")}
                className="font-semibold text-slate-700 hover:underline dark:text-slate-200"
              >
                Créer un compte
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
